import { WithSkeleton } from '@capsicum/common';

import { TotalBalanceComponent } from './TotalBalanceComponent';
import { TotalBalanceSkeleton } from './TotalBalanceSkeleton';

export const TotalBalance = WithSkeleton(TotalBalanceComponent, TotalBalanceSkeleton);
